export default __webpack_public_path__ + "static/media/main-image-header.5de57eb7.jpg";